import { render, staticRenderFns } from "./activity-booking-short-info.vue?vue&type=template&id=140f21c6&scoped=true&"
import script from "./activity-booking-short-info.ts?vue&type=script&lang=ts&"
export * from "./activity-booking-short-info.ts?vue&type=script&lang=ts&"
import style0 from "./activity-booking-short-info.scss?vue&type=style&index=0&id=140f21c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140f21c6",
  null
  
)

export default component.exports